export function PrivacyPage() {
  return (
    <div className="kt-prose">
      <h1 className="ab-h1" style={{ color: "var(--kt-ink)" }}>Privacy Policy</h1>
      <p style={{ fontSize: 13, color: "var(--kt-text-muted)" }}>Last updated: April 2026</p>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>What we collect</h2>
        <p>
          Aeronet Brain stores the thoughts, notes, and memories you explicitly capture, along with
          your email address (from Google or Apple sign-in) to identify your account. If you connect
          integrations, we also store:
        </p>
        <ul style={{ listStyle: "disc", paddingLeft: 24 }}>
          <li><strong style={{ color: "var(--kt-ink)" }}>Slack</strong> — workspace installation tokens and team ID</li>
          <li><strong style={{ color: "var(--kt-ink)" }}>Gmail</strong> — OAuth tokens and email metadata (sender, subject, date, thread ID — never email body content)</li>
          <li><strong style={{ color: "var(--kt-ink)" }}>Agent keys</strong> — API keys you create for automated agents</li>
        </ul>
      </section>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>How we use it</h2>
        <p>
          Your data is used solely to power your personal brain — semantic search, browsing, and AI
          chat. We do not sell your data, share it with third parties, or use it for advertising.
        </p>
      </section>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Where it's stored</h2>
        <p>
          Data is stored in AWS (us-east-1) using S3 Vectors for embeddings and DynamoDB for
          account information. All data is encrypted at rest and in transit.
        </p>
      </section>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>AI processing</h2>
        <p>
          When you chat with your brain or capture a thought, your text is sent to Amazon Bedrock
          (Claude and Titan Embed models) to generate responses and embeddings. AWS does not use
          this data to train foundation models.
        </p>
      </section>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Deleting your data</h2>
        <p>
          You can delete individual thoughts from the dashboard at any time. To permanently delete
          your account and all associated data — including thoughts, embeddings, agent keys, and
          integration connections — go to{" "}
          <strong style={{ color: "var(--kt-ink)" }}>Settings → Account → Delete account</strong>. Deletion is
          immediate and cannot be undone.
        </p>
      </section>

      <section>
        <h2 className="ab-h2" style={{ color: "var(--kt-ink)" }}>Contact</h2>
        <p>
          Questions?{" "}
          <a href="mailto:hello@example.com" style={{ color: "var(--kt-teal-ink)" }}>
            hello@example.com
          </a>
        </p>
      </section>
    </div>
  );
}
